/* eslint-disable @typescript-eslint/no-unused-vars */

export const TIME_API_URL = 'https://timeapi.io/api/Time/current/zone?timeZone=Europe/Bucharest';
export const STORAGE_KEY = 'trustedContestStart';
export const MAX_TIME_DRIFT_MS = 60 * 1000; // 1 minute

export const TUTORIAL_REGISTRATION_START_DATE = new Date(2026, 2, 23, 0, 0, 0);
export const TUTORIAL_REGISTRATION_END_DATE = new Date(2026, 3, 1, 23, 59, 59);
export const REGISTRATION_START_DATE = new Date(2026, 3, 3, 0, 0, 0);
export const REGISTRATION_END_DATE = new Date(2026, 3, 19, 23, 59, 59);
export const CONTEST_DATE = new Date(2026, 3, 21, 10, 0, 0);
export const PAST_CONTEST_DATE = new Date(2025, 4, 26, 10, 0, 0);

export const CONTEST_DURATION = 25 * 60 * 1000;

export const EURO_QUIZ_INFO_PAGE_URL = 'https://romania.representation.ec.europa.eu/euro-quiz_ro';

export const getTutorialAnnouncementMessage = (
  tutorialDateLabel: string,
  tutorialStartLabel: string,
  tutorialEndLabel: string,
) =>
  `Întâlnirea online de informare și pregătire a concursului EURO QUIZ va avea loc pe ${tutorialDateLabel}. Înscrierile la această întâlnire vor fi deschise între ${tutorialStartLabel} și ${tutorialEndLabel}.`;

export const getTutorialRegistrationOpenMessage = (tutorialDateLabel: string) =>
  `Înscrierile la întâlnirea online de informare și pregătire din data de ${tutorialDateLabel} sunt deschise.`;

export const getRegistrationClosedMessage = (
  registrationStartLabel: string,
  registrationEndLabel: string,
) => [
  `Perioada de înscrieri pentru întâlnirea de informare și pregătire online din data de 2 aprilie s-a încheiat. Cei care nu au reușit să participe vor găsi înregistrarea video a întâlnirii pe pagina concursului: `,
  `Urmeazǎ perioada înscrierilor în concursul Euro Quiz: ${registrationStartLabel} - ${registrationEndLabel}.`,
];

export const getRegistrationOpenMessage = (registrationEndLabel: string) => [
  'Înscrierile în concursul Euro Quiz sunt deschise',
  `Termenul-limită de înscriere este ${registrationEndLabel}. Accesează butonul "Creează cont" pentru înregistrarea în concurs.`,
];

export const getContestAnnouncementMessage = (_contestDateTimeLabel: string) =>
  `Concursul național Euro Quiz 2026 - Etapa națională, are loc pe data de 28 aprilie (ora României).`;

export const getContestInProgressMessage = (contestTimeLabel: string) =>
  `Etapa națională a concursului Euro Quiz a început la ora ${contestTimeLabel} și se află în desfășurare.`;

export const getContestEndedMessage = () => [
  `Concursul Național Euro Quiz s-a încheiat.`,
  'Vă mulțumim pentru participare!',
  `Pentru mai multe detalii, accesați pagina concursului:`,
];
